import { Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SaveWorkDoc from '../../assets/Materials/Checkliste Sicheres Arbeiten im Privathaushalt.pdf';
import MaterialPDF from './MaterialPDF';

export default function Materials(props) {

    const {t} = useTranslation()

    return(
        <Grid container sx={{maxWidth: 800, margin: "auto"}}>
            <Grid item xs={12} md={12}>
                <MaterialPDF title={t("material1Title")} 
                description={t("material1Description")} 
                doc={SaveWorkDoc}/>
            </Grid>
        </Grid>
    )
}